import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig, FilterService } from 'primeng/api';
import { ThemeService } from './service/theme.service';
import es from '../assets/i18n/es.json'; // Ajusta el path según la ubicación de tu archivo JSON

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    private primengConfig: PrimeNGConfig,
    private themeService: ThemeService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.themeService.applyStoredTheme();
    this.configurePrimeNG();
    this.configurarBuscadorMultiTermino();
  }

  // Sobrescribe el matcher 'contains' de PrimeNG (usado por el buscador global y
  // los filtros de columna) para que sea MULTI-TÉRMINO: exige que TODAS las
  // palabras del texto aparezcan (en cualquier orden/posición), e insensible a
  // mayúsculas y acentos. Ej: "juan perez" matchea "Juan Alberta Pérez Díaz".
  // Con un solo término se comporta igual que el 'contains' original.
  private configurarBuscadorMultiTermino() {
    const norm = (s: any) => String(s ?? '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '');
    this.filterService.register('contains', (value: any, filter: string | null): boolean => {
      if (filter === null || filter === undefined || String(filter).trim() === '') return true;
      if (value === null || value === undefined) return false;
      const haystack = norm(value);
      return norm(filter).trim().split(/\s+/).filter(Boolean).every(t => haystack.includes(t));
    });
  }

  configurePrimeNG() {
    this.primengConfig.setTranslation({
      dayNames: es.dayNames,
      dayNamesShort: es.dayNamesShort,
      dayNamesMin: es.dayNamesMin,
      monthNames: es.monthNames,
      monthNamesShort: es.monthNamesShort,
      today: es.today,
      weekHeader: es.weekHeader,
      firstDayOfWeek: es.firstDayOfWeek,
      startsWith: es.startsWith,
      contains: es.contains,
      notContains: es.notContains,
      endsWith: es.endsWith,
      equals: es.equals,
      notEquals: es.notEquals,
      matchAll: es.matchAll,
      matchAny: es.matchAny,
      clear: es.clear,
      apply: es.apply,
      addRule: es.addRule,
      removeRule: es.removeRule,
      noFilter: es.noFilter,
      lt: es.lt,
      lte: es.lte,
      gt: es.gt,
      gte: es.gte,
      dateIs: es.dateIs,
      dateIsNot: es.dateIsNot,
      dateBefore: es.dateBefore,
      dateAfter: es.dateAfter
    });
  }
}
